import useAccess from "@/hooks/useAccess";
import { TeamUserLicence, TeamUserRole } from "@shaarp/common";
import React from "react";
import { Navigate, RouteProps } from "react-router-dom";

type RouteProtectedProps = RouteProps & {
  requiredRoles?: TeamUserRole[];
  requiredLicences?: TeamUserLicence[];
  licenceActiveState?: boolean;
  fallbackPath?: string;
  element: React.ReactElement;
};

export const RouteProtected: React.FC<RouteProtectedProps> = ({
  requiredRoles,
  requiredLicences,
  fallbackPath = "/",
  licenceActiveState = true,
  element,
}) => {
  const { hasAccess } = useAccess();

  if (
    !hasAccess({
      requiredRoles,
      requiredLicences,
      licenceActiveState,
    })
  ) {
    return <Navigate to={fallbackPath} />;
  }

  return element;
};
